/** Visual constants for the collapsed multi-step tool stack. */
export const TOOL_STACK_MAX_VISIBLE_ICONS = 4;
export const TOOL_STACK_BUTTON_WIDTH_TRANSITION_MS = 180;
export const TOOL_STACK_LIST_HEIGHT_TRANSITION_MS = 190;
export const TOOL_STACK_NESTED_ITEM_TRANSITION_MS = 140;
export const TOOL_STACK_NESTED_ITEM_DELAY_MS = 35;
